import { RunnerStep } from '../../models/test-run.model';

export interface NumberedStep {
  step: RunnerStep;
  /** Anzeige-Nummer wie im Design: „1", „1.1", „1.2" (`page-testlauf.jsx:18-27`). */
  number: string;
  /** 0 fuer die oberste Ebene, 1 fuer Kinder einer Gruppe — steuert den Einzug. */
  depth: number;
  /** Gruppen-Kopfzeile: traegt kein eigenes Ergebnis und ist nicht anklickbar. */
  isGroup: boolean;
}

/**
 * Nummeriert die flache Schrittliste des Servers so, wie der Runner sie zeigt.
 *
 * <p>Das Backend liefert die Schritte in Ausfuehrungsreihenfolge mit einem
 * Verweis auf ihre Gruppe; die Nummer entsteht erst in der Anzeige. Ein Schritt,
 * dessen Gruppe nicht in derselben Liste steht, zaehlt auf oberster Ebene mit,
 * statt zu verschwinden.
 */
export function numberSteps(steps: readonly RunnerStep[]): NumberedStep[] {
  const ids = new Set(steps.map((step) => step.id));
  const childCounters = new Map<string, number>();
  const numbers = new Map<string, string>();
  let topLevel = 0;

  return steps.map((step) => {
    const parentId = step.parentStepResultId;
    const hasParent = parentId !== null && ids.has(parentId);
    if (!hasParent) {
      topLevel += 1;
      const number = String(topLevel);
      numbers.set(step.id, number);
      return { step, number, depth: 0, isGroup: step.kind === 'MODULE' };
    }
    const position = (childCounters.get(parentId) ?? 0) + 1;
    childCounters.set(parentId, position);
    const number = `${numbers.get(parentId) ?? String(topLevel)}.${position}`;
    numbers.set(step.id, number);
    return { step, number, depth: 1, isGroup: step.kind === 'MODULE' };
  });
}
